import React, { useEffect, useState } from "react";

import CustomCard from "../../components/reusable/CustomCard";
import Layout from "../../components/reusable/Layout";
import Title from "../../components/reusable/Title";
import TestItem from "./TestItem";

import classes from "./TestingSchedulePage.module.css";
import RestoreCustomWellnessPlan from "./RestoreCustomWellnessPlan";
import GNCCustomWellnessPlan from "./GNCCustomWellnessPlan";
import { SvgConverterType } from "../../reports/Report";

type TestType = { INDEX: number; VALUE: string };

type Dates = {
  INDEX: number;
  PERIOD: string | null;
  TITLE: string;
  TYPE: TestType[];
};

interface Props {
  data: { DATES: Dates[]; DESCRIPTION: string; INDEX: number; TITLE: string };
  onSvgConverter: SvgConverterType;
  isRestoreReport?: boolean;
  isEvityReport?: boolean;
  isGNCReport?: boolean;
  isFountainLife?: boolean;
}
const TestingSchedulePage = React.memo(
  ({
    data,
    onSvgConverter,
    isRestoreReport,
    isEvityReport,
    isGNCReport,
    isFountainLife,
  }: Props) => {
    const [imgLoad, setImgLoad] = useState(false);

    useEffect(() => {
      onSvgConverter("testItem", "resultTestItem", 685);
      setImgLoad(true);
    }, [onSvgConverter]);

    let imgTestItem = (
      <div id="testItem">
        <ul className={classes.innerContainer}>
          {data.DATES.map((item) => (
            <li className={classes.testItem} key={item.INDEX}>
              <TestItem item={item} />
            </li>
          ))}
        </ul>
      </div>
    );

    return (
      <Layout isEvityReport={isEvityReport}>
        <Title title={data.TITLE} />
        <CustomCard cardMargin="60px auto">
          <div id="resultTestItem" className={classes.imgRadarChart}>
            {!imgLoad && imgTestItem}
          </div>
        </CustomCard>
        {isRestoreReport ? (
          <RestoreCustomWellnessPlan />
        ) : (
          <CustomCard cardMargin="-20px auto" cardHeight={200}>
            {isFountainLife ? (
              <div className={classes.desctiption}>
                Our Fountain Life Nutritionist can work with you to tailor your
                macronutrient balance based on your overall health profile.
              </div>
            ) : (
              <div className={classes.desctiption}>{data.DESCRIPTION}</div>
            )}
          </CustomCard>
        )}
        {isGNCReport && <GNCCustomWellnessPlan />}
      </Layout>
    );
  }
);

export default TestingSchedulePage;
